import React from 'react';
import { BrowserRouter, Routes, Route, Link, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { HomePage } from './pages/HomePage';
import { DayPage } from './pages/DayPage';
import { GroupPage } from './pages/GroupPage';
import { LoginPage } from './pages/LoginPage';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useApp();
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    return <>{children}</>;
};

const Layout = ({ children }) => {
    const { studyTypeFilter, setStudyTypeFilter, resetData, userRole, isAuthenticated, logout } = useApp();

    if (!isAuthenticated) return <>{children}</>;

    return (
        <div className="min-h-screen bg-slate-900 text-white font-sans">
            <header className="sticky top-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-white/10 shadow-lg py-4">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <Link to="/" className="no-underline">
                            <h1 className="flex items-center gap-3 text-2xl font-bold bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent m-0">
                                <span className="text-3xl filter drop-shadow-md">🎓</span>
                                Turniket
                            </h1>
                        </Link>

                        <div className="flex items-center gap-4 w-full md:w-auto overflow-x-auto pb-2 md:pb-0">
                            <div className="flex bg-slate-800 p-1 rounded-lg border border-white/10 shrink-0">
                                <button
                                    className={`px-4 py-2 rounded-md transition-all font-medium text-sm ${studyTypeFilter === 'kunduzgi' ? 'bg-indigo-600 text-white shadow-sm' : 'text-slate-400 hover:text-white'}`}
                                    onClick={() => setStudyTypeFilter('kunduzgi')}
                                >
                                    Kunduzgi
                                </button>
                                <button
                                    className={`px-4 py-2 rounded-md transition-all font-medium text-sm ${studyTypeFilter === 'sirtqi' ? 'bg-indigo-600 text-white shadow-sm' : 'text-slate-400 hover:text-white'}`}
                                    onClick={() => setStudyTypeFilter('sirtqi')}
                                >
                                    Sirtqi
                                </button>
                            </div>

                            {userRole === 'admin' && (
                                <button
                                    className="px-4 py-2 bg-red-500/10 hover:bg-red-500/20 text-red-500 border border-red-500/20 rounded-lg transition-colors shrink-0"
                                    onClick={resetData}
                                >
                                    Сбросить
                                </button>
                            )}

                            <button
                                className="p-2 text-slate-400 hover:text-white transition-colors ml-auto md:ml-0"
                                onClick={logout}
                                title="Выйти"
                            >
                                <span className="text-xl">🚪</span>
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            <main className="container mx-auto px-4 py-8">
                {children}
            </main>
        </div>
    );
};

function App() {
    return (
        <AppProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
                        <Route path="/day/:dayId" element={<ProtectedRoute><DayPage /></ProtectedRoute>} />
                        <Route path="/group/:groupId" element={<ProtectedRoute><GroupPage /></ProtectedRoute>} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </AppProvider>
    );
}

export default App;
